import "./peoplePractise.scss";
import data from "./practise.json";
import Banner from "../../Common/Banner/Banner";
import TwoColumnLayout from "../../Common/TwoColumnLayout/TwoColumnLayout";
import iconPathURL from "../../Common/iconPath";

const CardView = (props) => {
  const body = () => {
    return (
      <div>
        <h2 className="address">{props.item.p1}</h2>
        <div>
          <p>{props.item.details1}</p>
          <p>{props.item.details2}</p>
        </div>
      </div>
    );
  };
  return (
    <div className="text-container-section col-xs-12 col-sm-12 col-md-8 col-lg-8">
      <TwoColumnLayout
        style="col-xs-12 col-sm-10 col-md-8 col-lg-11 second-column"
        imgStyle="col-xs-12 col-sm-2 col-md-4 col-lg-1 first-column"
        imgSrc={iconPathURL(`practise/${props.item.image}`)}
        body={body()}
      ></TwoColumnLayout>
    </div>
  );
};

export default function PeoplePractise(props) {
  const practiseData = data.data;

  return (
    <div className="people-container">
      <Banner
        imgSrc={iconPathURL("practise/practise_header.png")}
        title="People Practices"
      />
      <div>
        <div>
          {practiseData.list.map((item, index) => {
            return <CardView item={item} index={index} />;
          })}
        </div>
      </div>
    </div>
  );
}
